import templateUrl from './leads-policy-editor.component.html'

import { defaultPin, coloredPin, twoTonedCircle } from './marker-icons'
import { StatusTypeEnum } from '../../../core/services/data-services/leads.service';

/** A component used to edit a leads policy configuration. */
export const LeadsPolicyEditorComponent = {
    bindings: {
        leadsPolicy: "<",
        addLeadStatus: "&",
        deleteLeadStatus: "&",
        changeName: "&",
        changeStyle: "&",
        changeLeadStatusProperties: "&",
        changeOptimizationProperties: "&",
        changeImporterProperties: "&"
    },
    require: {
        editForm: "?^^form"
    },
    controller: class LeadsPolicyEditor {
        // Define the list of marker icon styles that can be assigned.
        markerIconStyles = [defaultPin, coloredPin, twoTonedCircle];
        leadsPolicy: any;
        addLeadStatus: ({ $event: any }) => void;
        changeLeadStatusProperties: ({ $event: any }) => void;
        constructor(private $uibModal, private utilityService) {
            'ngInject'
        }

        onAddLeadStatus() {
            this.editLeadStatus({}).then(leadStatus =>
                // Add the lead status to the policy.
                this.addLeadStatus({ $event: { leadStatus } })
            )
        }

        onEditLeadStatus(status, index) {
            this.editLeadStatus(status).then(leadStatus =>
                this.changeLeadStatusProperties({ $event: { leadStatus, index } })
            )
        }

        onMoveLeadStatus(leadStatus, index) {
            this.utilityService.moveItem(this.leadsPolicy.leadStatuses, leadStatus, index);
            this.changeLeadStatusProperties({ $event: { leadStatus, index } })
        }

        onSetDefaultLeadStatus(status, index) {
            this.leadsPolicy.leadStatuses.forEach(leadStatus => {
                leadStatus.isDefault = status === leadStatus
            })
            this.changeLeadStatusProperties({ $event: { leadStatus: status, index } })
        }

        /**
         * Open a modal to edit the given status and resolve with the updated value.
         * @param {any} status The lead status being edited.
         */
        editLeadStatus(status) {
            // Show an edit modal requiring all the fields to be filled out.
            const modal = this.$uibModal.open({
                component: "apexEditLeadStatusModal",
                resolve: {
                    leadStatus: function () {
                        return status;
                    }
                },
                windowClass: 'xx-dialog pagespinner',
                size: 'sm',
                backdrop: 'static'
            })

            return modal.result.then(leadStatus => {
                if (leadStatus.isDefault) {
                    // Ensure other lead statuses are unmarked as default.
                    this.leadsPolicy.leadStatuses.forEach(leadStatus => {
                        leadStatus.isDefault = status === leadStatus
                    })
                }
                return leadStatus
            })
        }

        leadStatusType(status) {
            const statuses = Object.keys(StatusTypeEnum)
                .reduce((types, key) => {
                    if ((status.leadStatusType & StatusTypeEnum[key]) !== 0) {
                        types.push(key)
                    }
                    return types
                }, [])
            return statuses.join(", ")
        }
    },
    templateUrl
}
